import script from "./MaterialDuplicateDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialDuplicateDialog.vue?vue&type=script&setup=true&lang=js"

import "./MaterialDuplicateDialog.vue?vue&type=style&index=0&id=7ffacc21&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ffacc21"]])

export default __exports__